// ButtonSecondary: Plasmic-designed text button. OPTIONAL window-button
// behaviour, same rules as OP1WebAWButton (see useWindowButton.js):
//   click -> opens the window; click again -> closes it.
// Set a `windowId` (Text prop, add it in Studio) to link it to a window,
// e.g. "missionEssay" for the OP1WebWindow on the desktop layer. Without a
// windowId it behaves exactly as before.
// The root gets data-state="closed|open|active" / data-open / data-focused /
// aria-pressed for styling.
//
// This file is owned by us: `plasmic sync` never overwrites it.
import * as React from "react";
import { PlasmicButtonSecondary } from "./plasmic/one_platform/PlasmicButtonSecondary";
import useWindowButton from "./useWindowButton";

function ButtonSecondary_({ windowId, onClick, ...props }, ref) {
  const { enabled, state, isOpen, isFocused, handleClick } =
    useWindowButton(windowId);

  // The click handler lives on the inner link; it calls the `onClick` prop,
  // so composing it here is enough.
  const composedOnClick =
    enabled || onClick
      ? (...args) => {
          onClick?.(...args);
          handleClick();
        }
      : undefined;

  const rootProps = enabled
    ? {
        ref,
        "data-state": state,
        "data-open": isOpen,
        "data-focused": isFocused,
        "aria-pressed": state === "active",
      }
    : { ref };

  return (
    <PlasmicButtonSecondary
      {...props}
      wrapp={rootProps}
      onClick={composedOnClick}
    />
  );
}

const ButtonSecondary = React.forwardRef(ButtonSecondary_);

export default ButtonSecondary;
